import * as React from 'react';
import { createRoot } from 'react-dom/client';
import type { BaseAnswerType, RenderViewPropsType, RenderViewReturnType, DefaultContinueHandlerType } from '../types';
import { SimpleButtonGroup } from '../../../React/features/Chat/features/SimpleButtonGroup';

export const COMPONENT_IDENTIFIER = 'simple-button-group';

export type RenderSimpleButtonGroupPropsType = RenderViewPropsType<{
  answers: Required<BaseAnswerType>[];
  balloonContents?: React.ReactNode;
}>

export const renderSimpleButtonGroup = async (props: RenderSimpleButtonGroupPropsType): RenderViewReturnType => {
  const { chatRoot, keyName } = props;

  // レンダーするためのルート要素を作成
  const viewContainer = document.createElement('div');
  const viewRoot = createRoot(viewContainer);

  // コンテナ要素にクラス付与
  viewContainer.classList.add(`chat-${COMPONENT_IDENTIFIER}-container`);
  viewContainer.classList.add(keyName);

  // チャットルートにコンテナ要素をappendする
  chatRoot.appendChild(viewContainer);

  return new Promise((resolve) => {
    const continueHandler = (args: DefaultContinueHandlerType) => resolve({ ...args, viewRootDomReference: viewContainer });

    // appendしたコンテナ要素にJsxをレンダリングする
    viewRoot.render(<SimpleButtonGroup {...props} continueHandler={continueHandler} />);
  });
};
